module.exports = __webpack_public_path__ + "img/img25.f65f7e2b.svg";